import "../../field-container/field-container";
import "../../textfield/money-field";
import "../../alert/alert";

import { type TemplateResult, html } from "lit";
import { msg } from "@lit/localize";

import { WizardStep } from "../../wizard/wizard-step";
import { FormController } from "../../../forms/form-controller";
import { FormControl } from "../../../forms/form-control";
import { required } from "../../../forms/validators";
import { getConfiguration } from "../../../utils/configuration";
import { WizardStepSubmittedData } from "../../wizard/events";
import { NotaryEstimationWizard } from "../notary-estimation-wizard";

export declare interface NotaryEstimationWizardStep01PropertyValueFormData {
	propertyValue: string;
}

export class NotaryEstimationWizardStep01PropertyValue extends WizardStep<
	NotaryEstimationWizard,
	NotaryEstimationWizardStep01PropertyValueFormData
> {
	protected createForm(): FormController<NotaryEstimationWizardStep01PropertyValueFormData> {
		return new FormController<NotaryEstimationWizardStep01PropertyValueFormData>(this, {
			propertyValue: new FormControl("", [required]),
		});
	}

	protected renderContent(): TemplateResult {
		return html`
			<oz-field-container size="s">
				<oz-money-field label="${msg("Hodnota děděného majetku")}" required ${this._form.attach("propertyValue")}>
					<span slot="suffix">Kč</span>
				</oz-money-field>
			</oz-field-container>
		`;
	}

	protected override async createAdditionalSubmitData(
		data: NotaryEstimationWizardStep01PropertyValueFormData,
	): Promise<Partial<WizardStepSubmittedData<NotaryEstimationWizardStep01PropertyValueFormData>>> {
		return {
			gtmDataLayerItems: [
				{
					event: `${this.configuration.wizardName}_${this.stepDetails.name}`,
					language_code: getConfiguration().languageCode,
					property_value: data.propertyValue,
				},
			],
		};
	}
}
